export default "__VITE_ASSET__DgZbUDso__"